module.exports = __webpack_public_path__ + "static/media/image0.b0a7e521.jpeg";